import { render, staticRenderFns } from "./NivelFornecedor.vue?vue&type=template&id=6703a6fe"
import script from "./NivelFornecedor.vue?vue&type=script&lang=js"
export * from "./NivelFornecedor.vue?vue&type=script&lang=js"
import style0 from "./NivelFornecedor.vue?vue&type=style&index=0&id=6703a6fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports